import React from "react";
import { equipmentTypes } from "../data/equipmentTypes";

export default function AddUnitCard({ eqType, onAdd }) {
  const def = equipmentTypes[eqType];
  return (
    <button className="add-unit-card" onClick={() => onAdd(eqType)}>
      <div className="add-unit-icon">+</div>
      <div className="add-unit-label">Add {def?.label || eqType}</div>
    </button>
  );
}
